import { giphyLightGrey } from '@giphy/js-brand'
import React, { SyntheticEvent, ReactNode } from 'react'
import styled, { css } from 'styled-components'
import { desktop } from 'shared/util/media-query'
import { useHistory } from 'react-router'
import { TrendingHeader } from 'shared/components/mobile-trending-header'

// Chris says this is it, universal font size for section headers
const SECTION_HEADER_FONT_SIZE = 15

const containerCss = css`
    font-size: ${SECTION_HEADER_FONT_SIZE}px;
    font-weight: 600;
    -webkit-font-smoothing: antialiased;
    color: ${giphyLightGrey};
    padding: 0 8px;
    ${desktop.css`
        padding: 0 8px 0 0;
    `}
    font-family: interface;
    display: flex;
    justify-content: flex-end;
    text-align: left;
    margin-bottom: 6px;
`

const H2Container = styled.h2<{ isHomepage: boolean }>`
    ${containerCss}
    ${desktop.css`
        font-size: 24px;
        padding-top: 0px;
    `}
    color: #fff;
    font-size: ${props => (props.isHomepage ? '22px' : '17px')};
    align-items: center;
    justify-content: flex-start;
    padding-top: 7px;
`

const LinkContainer = styled.a<{ isHomepage: boolean }>`
    ${containerCss}
    cursor: pointer;
    padding-top: ${props => (props.isHomepage ? '10px' : '0px')} !important;
`

const Arrow = styled.div`
    font-size: 11px;
    margin-left: 3px;
    height: 13px;
    display: inline-block;
`

const Title = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 17px;
`

const Icon = styled.div`
    width: 22px;
    height: 24px;
    margin-right: 8px;
    position: relative;
    ${desktop.css`
        height: 24px;
        width: 24px;
        margin-right: 10px;
    `}
    & svg {
        width: 100%;
        height: 100%;
        position: absolute;
    }
`

type Props = {
    label: string
    url?: string
    className?: string
    isHistoryPush?: boolean
    historyState?: any
    icon?: ReactNode
    seeAllLabel?: string
    isHomepage?: boolean
    isMobileTrending?: boolean
}

const SectionHeader = ({
    label,
    url = '',
    className = '',
    isHistoryPush,
    historyState = {},
    icon,
    isHomepage = false,
    isMobileTrending = false,
}: Props) => {
    const history = useHistory()
    const onClick = (e: SyntheticEvent) => {
        if (isHistoryPush) {
            e.preventDefault()
            history.push(url, historyState)
        }
    }
    return url ? (
        <LinkContainer href={url} className={className} onClick={onClick} isHomepage={isHomepage}>
            <h2>
                {label} <Arrow className="ss-icon ss-navigateright" />
            </h2>
        </LinkContainer>
    ) : (
        <H2Container isHomepage={isHomepage} className={className}>
            {icon && <Icon>{icon}</Icon>}
            {isMobileTrending ? <TrendingHeader size={22} /> : label}
        </H2Container>
    )
}

export const SectionHeaderWithSeeAll = ({
    label,
    url = '',
    className = '',
    isHistoryPush,
    historyState,
    icon,
    seeAllLabel = 'See All',
    isHomepage = false,
    isMobileTrending = false,
}: Props) => {
    return (
        <Title className={className}>
            <SectionHeader
                label={label}
                isHistoryPush={isHistoryPush}
                historyState={historyState}
                icon={icon}
                isHomepage={isHomepage}
                isMobileTrending={isMobileTrending}
            />
            <SectionHeader
                label={seeAllLabel}
                url={url}
                isHistoryPush={isHistoryPush}
                historyState={historyState}
                isHomepage={isHomepage}
            />
        </Title>
    )
}
export default SectionHeader
